import {
  GET_CAPE,
  ADD_CAPE,
  UPDATE_CAPE,
  DELETE_CAPE,
  REQUEST_CAPE,
  ERROR_XHR
} from '../mutation-types'

import toastr from 'toastr'

const state = {
  all: []
}

const mutations = {
  [GET_CAPE] (state, capes) {
    state.all = capes
  },
  [ADD_CAPE] (state, contact) {
    state.all.push(contact)
    toastr.success('Le CAPE a été créé')
  },
  [UPDATE_CAPE] (state, oldcontact, updatedcontact) {
    state.all.$remove(oldcontact)
    state.all.push(updatedcontact)
    toastr.success('Le CAPE a été modifié')
  },
  [DELETE_CAPE] (state, contact) {
    state.all.$remove(contact)
    toastr.success('Le CAPE a été supprimé')
  },
  [REQUEST_CAPE] (state) {
    state.error = false
  },
  [ERROR_XHR] (state, error) {
    console.log(state)
    console.log(error)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/capes.js